import { Component, OnInit, Input, Output, ViewChild, ElementRef, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take, finalize } from 'rxjs/operators';

import { BrandService } from '../../../brands/services/brand.service';

@Component({
  selector: 'app-dialog-search-brand',
  templateUrl: './dialog-search-brand.component.html',
  styleUrls: ['./dialog-search-brand.component.sass']
})
export class DialogSearchBrandComponent implements OnInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('form') form: NgForm;

  results = [];
  searching = false;
  term = '';

  constructor(
    private brandService: BrandService,
    public dialogRef: MatDialogRef<DialogSearchBrandComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onSelect(brand) {
    this.dialogRef.close(brand);
  }

  onSubmit(form) {
    this.searching = true;

    this.brandService.fetch({
      name: this.term
    })
      .pipe(
        take(1),
        finalize(() => {
          this.searching = false;
        })
      )
      .subscribe((response: any) => {
        this.results = response.items;
      });
  }
}
